import styled from 'styled-components';
import CancelledActiveSvg from '../../assets/mytrips/cancelled-active.svg';

const CancelledActiveIcon = styled(CancelledActiveSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '3.2rem'};
  height: ${props => props.height || '2.2rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default CancelledActiveIcon;
